var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"order-view-actions-spec-paid"}},[(!_vm.isQuoteOwner && (!_vm.quoteSelected.quote.claim || (_vm.quoteSelected.quote.claim && !_vm.quoteSelected.quote.claim.closed)))?_c('OrderViewActionClaim'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }